import { useUsernameFromId } from '~/hooks/use-username-from-id'

export const SecondaryContribuitor = ({ userId }: { userId: string }) => {
  const { username } = useUsernameFromId(userId)

  return <p>{username}</p>
}
